var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 41.25C20.5625 41.25 19.974 41.0052 19.4844 40.5156C18.9948 40.026 18.75 39.4375 18.75 38.75V21.25C18.75 20.5625 18.9948 19.974 19.4844 19.4844C19.974 18.9948 20.5625 18.75 21.25 18.75H38.75C39.4375 18.75 40.026 18.9948 40.5156 19.4844C41.0052 19.974 41.25 20.5625 41.25 21.25H31.25C29.7708 21.25 28.5677 21.7135 27.6406 22.6406C26.7135 23.5677 26.25 24.7708 26.25 26.25V33.75C26.25 35.2292 26.7135 36.4323 27.6406 37.3594C28.5677 38.2865 29.7708 38.75 31.25 38.75H41.25C41.25 39.4375 41.0052 40.026 40.5156 40.5156C40.026 41.0052 39.4375 41.25 38.75 41.25H21.25ZM31.25 36.25C30.5625 36.25 29.974 36.0052 29.4844 35.5156C28.9948 35.026 28.75 34.4375 28.75 33.75V26.25C28.75 25.5625 28.9948 24.974 29.4844 24.4844C29.974 23.9948 30.5625 23.75 31.25 23.75H40C40.6875 23.75 41.276 23.9948 41.7656 24.4844C42.2552 24.974 42.5 25.5625 42.5 26.25V33.75C42.5 34.4375 42.2552 35.026 41.7656 35.5156C41.276 36.0052 40.6875 36.25 40 36.25H31.25ZM35 31.875C35.5417 31.875 35.9896 31.6979 36.3438 31.3438C36.6979 30.9896 36.875 30.5417 36.875 30C36.875 29.4583 36.6979 29.0104 36.3438 28.6562C35.9896 28.3021 35.5417 28.125 35 28.125C34.4583 28.125 34.0104 28.3021 33.6562 28.6562C33.3021 29.0104 33.125 29.4583 33.125 30C33.125 30.5417 33.3021 30.9896 33.6562 31.3438C34.0104 31.6979 34.4583 31.875 35 31.875Z",
    fill: "#FF8C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIWallet);
export default __webpack_public_path__ + "static/media/iWallet.96acbf3efc4b38d67e24394ff2aac5cb.svg";
export { ForwardRef as ReactComponent };